import React from "react";
import { cn } from "@/utils/utils";
import IconContainer from "@/components/ui/icon-container";
import { Bullet } from "@dreamhub/designsystem/icons";

export interface StatusBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  statusColor?: string;
  containerClassName?: string;
  isTable?: boolean;
  icon?: React.ReactNode;
}

function StatusBadge({
  className,
  children,
  statusColor,
  containerClassName,
  isTable,
  icon,
  ...props
}: StatusBadgeProps) {
  return (
    <div className={cn("w-full overflow-hidden", containerClassName)}>
      <div className="inline-block max-w-full min-w-0">
        <div
          className={cn(
            "flex gap-[6px] items-center border-[0.5px] border-border-border2 text-sm truncate py-1 px-2 w-fit max-w-full",
            isTable ? "rounded-md font-normal" : "rounded-md",
            className
          )}
          {...props}
        >
          <IconContainer
            size="xs"
            className="-translate-y-[0.5px]"
            style={
              statusColor
                ? {
                    color: statusColor
                  }
                : undefined
            }
          >
            {icon ?? <Bullet />}
          </IconContainer>
          {children}
        </div>
      </div>
    </div>
  );
}

export { StatusBadge };
